{
  "name": "Undergrowth",
  "ambInd": "3",
  "skyDome": true,
  "skyDomeCol0": "#3983a2",
  "skyDomeCol1": "#87ceeb",
  "skyDomeCol2": "#dce8ed",
  "shadowR": 1297.054320662896,
  "ambient": "#97a0a8",
  "light": "#f2f8fc",
  "sky": "#dce8ed",
  "fog": 9280160,
  "fogD": 2000,
  "camPos": [0, 38, -387],
  "spawns": [[345, 2, -169, 0, 1, 0], [100, 2, -229, 0, 2, 0], [56, 13, -449, 0, 1, 0], [332, 2, -543, 0, 0, 0], [332, 2, -189, 0, 0, 0], [280, 13, -177, 0, 2, 0], [-18, 2, -104, 0, 1, 0], [182, 2, 26, 0, 3, 0]],
  "objects": [{
    "p": [3, 0, -211],
    "s": [224, 2, 190],
    "c": "#9d9d9d",
    "t": 1
  }, {
    "p": [190, 0, -58],
    "s": [134, 2, 200],
    "c": "#9d9d9d",
    "t": 1
  }, {
    "p": [210, -16, -226],
    "s": [162, 29, 120],
    "c": "#9d9d9d",
    "t": 1
  }, {
    "p": [233, 2, -141],
    "s": [44, 11, 50],
    "i": 9,
    "c": "#9d9d9d",
    "t": 1,
    "d": 3
  }, {
    "p": [218, -11, -321],
    "s": [62, 24, 70],
    "c": "#9d9d9d",
    "t": 1
  }, {
    "p": [107, 11, -334],
    "s": [44, 2, 57],
    "c": "#9d9d9d",
    "t": 1
  }, {
    "p": [-5, 11, -385],
    "s": [180, 2, 158],
    "c": "#9d9d9d",
    "t": 1
  }, {
    "p": [295, 0, -32],
    "s": [76, 2, 50],
    "c": "#434343",
    "e": "#18180a"
  }, {
    "p": [407, 0, -90],
    "s": [148, 2, 176],
    "c": "#434343",
    "e": "#18180a"
  }, {
    "p": [-5, 19, -440],
    "s": [74, 2, 77],
    "c": "#9d9d9d",
    "t": 1
  }, {
    "p": [256, 0, -400],
    "s": [126, 2, 128],
    "c": "#9d9d9d",
    "t": 1
  }, {
    "p": [222, 2, -378],
    "s": [46, 11, 44],
    "i": 9,
    "c": "#9d9d9d",
    "t": 1,
    "d": 1
  }, {
    "p": [379, 0, -481],
    "s": [120, 2, 230],
    "c": "#9d9d9d",
    "t": 1
  }, {
    "p": [61, 0, -87],
    "s": [124, 2, 58],
    "c": "#9d9d9d",
    "t": 1
  }, {
    "p": [23, 0, -42],
    "s": [48, 2, 32],
    "c": "#9d9d9d",
    "t": 1
  }, {
    "p": [400, 0, -350],
    "s": [46, 2, 32],
    "c": "#9d9d9d",
    "t": 1
  }, {
    "p": [335, 0, -268],
    "s": [145, 2, 44],
    "c": "#9d9d9d",
    "t": 1
  }, {
    "p": [378, 0, -312],
    "s": [90, 2, 44],
    "c": "#9d9d9d",
    "t": 1
  }, {
    "p": [-49, -4, -288],
    "s": [48, 17, 36],
    "c": "#9d9d9d",
    "t": 1
  }, {
    "p": [310, 2, -263],
    "s": [38, 11, 46],
    "i": 9,
    "c": "#9d9d9d",
    "t": 1,
    "d": 2
  }, {
    "p": [294, 0, 17],
    "s": [78, 38, 50],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [114, 0, -40],
    "s": [34, 46, 36],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [408, 8, -4],
    "s": [147, 50, 3],
    "c": "#ffffff",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [471, 0, -323],
    "s": [96, 54, 154],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [406, 0, -268],
    "s": [35, 54, 44],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [297, 0, -534],
    "s": [44, 41, 162],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [371, 0, -605],
    "s": [104, 41, 32],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-38, 38, -49],
    "s": [76, 4, 28],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [23, 0, -24],
    "s": [48, 23, 4]
  }, {
    "p": [121, 0, -201],
    "s": [17, 34, 88],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [170, 0, -144],
    "s": [82, 34, 44],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-111, 0, -448],
    "s": [62, 67, 156],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-46, 0, -502],
    "s": [80, 49, 48],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [40, 0, -494],
    "s": [92, 67, 64],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [32, 13, -432],
    "s": [4, 10, 68],
    "e": "#18180a"
  }, {
    "p": [-5, 13, -400],
    "s": [70, 10, 4],
    "e": "#18180a"
  }, {
    "p": [-42, 13, -410],
    "s": [4, 10, 24],
    "e": "#18180a"
  }, {
    "p": [-61, 19, -451],
    "s": [38, 2, 58],
    "c": "#9d9d9d",
    "t": 1
  }, {
    "p": [-62, 13, -410],
    "s": [36, 8, 24],
    "i": 9,
    "c": "#9d9d9d",
    "t": 1,
    "d": 3
  }, {
    "p": [187, 13, -287],
    "s": [4, 19, 12],
    "e": "#18180a"
  }, {
    "p": [187, 13, -319],
    "s": [4, 15, 4],
    "e": "#18180a"
  }, {
    "p": [187, 13, -350],
    "s": [4, 19, 12],
    "e": "#18180a"
  }, {
    "p": [187, 13, -343],
    "s": [4, 7, 2],
    "e": "#18180a"
  }, {
    "p": [187, 13, -279],
    "s": [4, 7, 4],
    "e": "#18180a"
  }, {
    "p": [187, 13, -233],
    "s": [4, 19, 23],
    "e": "#18180a"
  }, {
    "p": [187, 13, -251],
    "s": [4, 11, 13],
    "e": "#18180a"
  }, {
    "p": [355, 0, -350],
    "s": [44, 54, 32],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [289, 0, -343],
    "s": [88, 54, 114],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [386, 6, -67],
    "s": [10, 50, 10],
    "c": "#707070",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [386, 6, -118],
    "s": [10, 21, 10],
    "c": "#707070",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [208, 0, 37],
    "s": [6, 39, 7],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [230, 0, 37],
    "s": [6, 39, 7],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [248, 0, 40],
    "s": [8, 45, 8],
    "c": "#6e6e6e",
    "e": "#18180a",
    "t": 5,
    "bo": 1
  }, {
    "p": [190, 0, 40],
    "s": [8, 45, 8],
    "c": "#6e6e6e",
    "e": "#18180a",
    "t": 5,
    "bo": 1
  }, {
    "p": [191, 39, 40],
    "s": [112, 4, 7],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [191, 30, 40],
    "s": [112, 4, 7],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [191, 34, 40],
    "s": [114, 5, 4],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [149, 0, 37],
    "s": [6, 39, 7],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [171, 0, 37],
    "s": [6, 39, 7],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [133, 0, 40],
    "s": [8, 45, 8],
    "c": "#6e6e6e",
    "e": "#18180a",
    "t": 5,
    "bo": 1
  }, {
    "p": [191, 0, 40],
    "s": [112, 32, 4],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [133, 2, 12],
    "s": [21, 1, 71],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [134, 2, -39],
    "s": [15, 1, 31],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [188, 2, -50],
    "s": [49, 1, 41],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [211, 2, 28],
    "s": [29, 1, 20],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [241, 2, 28],
    "s": [31, 1, 40],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [150, 2, -3],
    "s": [13, 1, 12],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [92, 2, -61],
    "s": [90, 1, 13],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [143, 3, 34],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#85aa6c"
  }, {
    "p": [130, 3, 28],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.05, 0],
    "c": "#85aa6c"
  }, {
    "p": [165, 3, 35],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.35, 0],
    "c": "#85aa6c"
  }, {
    "p": [136, 3, -47],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": "#85aa6c"
  }, {
    "p": [110, 0, -6],
    "s": [28, 39, 36],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [110, 0, 27],
    "s": [38, 49, 36],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [114, 0, -23],
    "s": [38, 31, 25],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [110, 39, -6],
    "s": [28, 2, 36],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [114, 31, -23],
    "s": [38, 2, 25],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [114, 46, -40],
    "s": [34, 2, 36],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [110, 49, 27],
    "s": [38, 2, 36],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [88, 0, -45],
    "s": [28, 38, 36],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [66, 0, -40],
    "s": [38, 42, 36],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [46, 0, -14],
    "s": [38, 36, 36],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [8, 0, -9],
    "s": [38, 31, 36],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [-4, 0, -19],
    "s": [30, 54, 32],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [88, 38, -45],
    "s": [28, 2, 36],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [66, 42, -40],
    "s": [38, 2, 36],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [46, 36, -14],
    "s": [38, 2, 36],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [8, 31, -9],
    "s": [38, 2, 36],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [-4, 54, -19],
    "s": [30, 2, 32],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [78, 2, -70],
    "s": [45, 1, 5],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [39, 2, -44],
    "s": [16, 1, 40],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [15, 2, -38],
    "s": [32, 1, 26],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [193, 0, -48],
    "s": [26, 53, 26],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [193, 2, -48],
    "s": [28, 7, 28],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [205, 0, -36],
    "s": [6, 53, 6],
    "c": "#6e6e6e",
    "e": "#18180a",
    "t": 5
  }, {
    "p": [205, 0, -60],
    "s": [6, 53, 6],
    "c": "#6e6e6e",
    "e": "#18180a",
    "t": 5
  }, {
    "p": [181, 0, -60],
    "s": [6, 53, 6],
    "c": "#6e6e6e",
    "e": "#18180a",
    "t": 5
  }, {
    "p": [181, 0, -36],
    "s": [6, 53, 6],
    "c": "#6e6e6e",
    "e": "#18180a",
    "t": 5
  }, {
    "p": [193, 53, -48],
    "s": [32, 4, 32],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [193, 61, -48],
    "s": [32, 4, 32],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [193, 57, -48],
    "s": [30, 4, 30],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [170, 2, 21],
    "s": [53, 1, 36],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [194, 2, -24],
    "s": [31, 1, 11],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [216, 2, -51],
    "s": [7, 1, 25],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [190, 2, -74],
    "s": [37, 1, 7],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [200, 2, -69],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [188, 2, -69],
    "s": [12, 12, 12],
    "i": 8,
    "r": [0, 1.57, 0]
  }, {
    "p": [194, 8, -69],
    "s": [24, 7, 12],
    "l": 1,
    "c": "#3964a2",
    "t": 5,
    "ab": 1
  }, {
    "p": [269, 0, 43],
    "s": [35, 53, 41],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [257, 0, 26],
    "s": [21, 29, 21],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [247, 2, 3],
    "s": [18, 1, 10],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [257, 29, 26],
    "s": [21, 2, 21],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [269, 53, 43],
    "s": [35, 2, 41],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [242, 3, 34],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -1.22, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [251, 3, 11],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -1.04, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [199, 3, -30],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -1.39, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [209, 3, -66],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.36, 0],
    "c": "#85aa6c"
  }, {
    "p": [171, 3, -62],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.88, 0],
    "c": "#85aa6c"
  }, {
    "p": [70, 3, -61],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.23, 0],
    "c": "#85aa6c"
  }, {
    "p": [43, 3, -36],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -1.39, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [14, 3, -30],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.88, 0],
    "c": "#85aa6c"
  }, {
    "p": [148, 0, 75],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "c": "#4c663e"
  }, {
    "p": [212, -9, 75],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#4c663e"
  }, {
    "p": [258, -30, 101],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.35, 0],
    "c": "#4c663e"
  }, {
    "p": [156, -36, 116],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.35, 0],
    "c": "#4c663e"
  }, {
    "p": [257, 0, -14],
    "s": [5, 30, 5],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [257, 0, -50],
    "s": [5, 30, 5],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [257, 30, -32],
    "s": [5, 5, 43],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [257, 0, -56],
    "s": [8, 56, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [257, 0, -8],
    "s": [8, 56, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [258, 0, -163],
    "s": [8, 38, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [258, 0, -109],
    "s": [8, 38, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [272, 38, -112],
    "s": [36, 4, 110],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [291, 46, -110],
    "s": [74, 4, 114],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [293, 42, -111],
    "s": [74, 4, 108],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [255, 2, -103],
    "s": [21, 1, 92],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [242, 2, -83],
    "s": [5, 1, 29],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [261, 2, -50],
    "s": [25, 1, 14],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [278, 2, -53],
    "s": [9, 1, 6],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [258, 2, -11],
    "s": [15, 1, 18],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [273, 2, -11],
    "s": [15, 1, 6],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [185, 2, -115],
    "s": [65, 1, 23],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [134, 2, -115],
    "s": [37, 1, 12],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [196, 2, -101],
    "s": [29, 1, 5],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [89, 2, -130],
    "s": [53, 1, 47],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [96, 2, -103],
    "s": [20, 1, 7],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [294, 38, 17],
    "s": [80, 4, 56],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [294, 46, 17],
    "s": [80, 4, 56],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [294, 42, 17],
    "s": [76, 4, 50],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [345, 61, -32],
    "s": [180, 5, 50],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [257, 35, -32],
    "s": [3, 21, 43],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [291, 56, -32],
    "s": [76, 5, 56],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [291, 66, -32],
    "s": [76, 5, 56],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [293, 50, -8],
    "s": [77, 7, 6],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [293, 50, -56],
    "s": [77, 7, 6],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [264, 3, -51],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.4, 0],
    "c": "#85aa6c"
  }, {
    "p": [251, 3, -64],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.18, 0],
    "c": "#85aa6c"
  }, {
    "p": [208, 3, -112],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#85aa6c"
  }, {
    "p": [263, 40, -32],
    "s": [9, 5, 50],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [295, 40, -51],
    "s": [55, 5, 12],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [327, 40, -32],
    "s": [9, 5, 50],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [333, 2, -50],
    "s": [5, 28, 5],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [333, 30, -32],
    "s": [5, 5, 41],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [333, 2, -14],
    "s": [5, 28, 5],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [333, 35, -32],
    "s": [3, 25, 55],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [295, 40, -13],
    "s": [55, 5, 12],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [333, 8, -56],
    "s": [7, 38, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [333, 0, -8],
    "s": [7, 45, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [251, 2, -88],
    "s": [1, 19, 4],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#bbbbbb",
    "t": 2
  }, {
    "p": [251, 2, -96],
    "s": [1, 19, 4],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#bbbbbb",
    "t": 2
  }, {
    "p": [293, 30, -9],
    "s": [77, 5, 2],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [293, 30, -55],
    "s": [77, 5, 2],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [258, 0, -109],
    "s": [7, 12, 101],
    "c": "#696969",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [258, 0, 10],
    "s": [7, 12, 28],
    "c": "#696969",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [371, 0, -212],
    "s": [161, 2, 68],
    "c": "#9d9d9d",
    "t": 1
  }, {
    "p": [333, 8, -75],
    "s": [5, 48, 31],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [429, 42, -91],
    "s": [16, 6, 173],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [422, 56, -94],
    "s": [30, 5, 178],
    "c": "#8c8c8c",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [383, 61, -105],
    "s": [104, 5, 96],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [342, 42, -77],
    "s": [18, 6, 144],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [386, 42, -12],
    "s": [70, 6, 16],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [403, 42, -169],
    "s": [36, 6, 15],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [386, 0, -67],
    "s": [12, 6, 12],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [386, 56, -118],
    "s": [12, 5, 12],
    "c": "#e1e1e1",
    "e": "#18180a"
  }, {
    "p": [386, 2, -118],
    "s": [12, 4, 12],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [333, 8, -172],
    "s": [7, 38, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [333, 0, -180],
    "s": [8, 53, 6],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [383, 66, -81],
    "s": [108, 5, 152],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [441, 30, -214],
    "s": [7, 4, 49],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [441, 34, -213],
    "s": [4, 5, 51],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [441, 2, -215],
    "s": [4, 29, 48],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [441, 0, -187],
    "s": [8, 45, 8],
    "c": "#6e6e6e",
    "e": "#18180a",
    "t": 5,
    "bo": 1
  }, {
    "p": [441, 0, -242],
    "s": [8, 45, 8],
    "c": "#6e6e6e",
    "e": "#18180a",
    "t": 5,
    "bo": 1
  }, {
    "p": [437, -5, -204],
    "s": [7, 39, 6],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [437, -5, -225],
    "s": [7, 39, 6],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [340, 8, -177],
    "s": [8, 34, 3],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [356, 18, -189],
    "s": [48, 1, 12],
    "pe": 1,
    "c": "#878787",
    "t": 2
  }, {
    "p": [346, 34, -189],
    "s": [28, 1, 12],
    "pe": 1,
    "c": "#878787",
    "t": 2
  }, {
    "p": [359, 1, -194],
    "s": [1, 35, 1],
    "c": "#757575",
    "t": 5
  }, {
    "p": [333, 1, -194],
    "s": [1, 35, 1],
    "c": "#757575",
    "t": 5
  }, {
    "p": [333, 1, -184],
    "s": [1, 35, 1],
    "c": "#757575",
    "t": 5
  }, {
    "p": [359, 1, -184],
    "s": [1, 35, 1],
    "c": "#757575",
    "t": 5
  }, {
    "p": [379, 1, -194],
    "s": [1, 19, 1],
    "c": "#757575",
    "t": 5
  }, {
    "p": [379, 1, -184],
    "s": [1, 19, 1],
    "c": "#757575",
    "t": 5
  }, {
    "p": [359, 9, -194],
    "s": [2, 1, 2],
    "l": 1,
    "c": "#757575",
    "t": 5
  }, {
    "p": [333, 9, -194],
    "s": [2, 1, 2],
    "l": 1,
    "c": "#757575",
    "t": 5
  }, {
    "p": [333, 26, -194],
    "s": [2, 1, 2],
    "l": 1,
    "c": "#757575",
    "t": 5
  }, {
    "p": [359, 26, -194],
    "s": [2, 1, 2],
    "l": 1,
    "c": "#757575",
    "t": 5
  }, {
    "p": [379, 9, -194],
    "s": [2, 1, 2],
    "l": 1,
    "c": "#757575",
    "t": 5
  }, {
    "p": [379, 9, -184],
    "s": [2, 1, 2],
    "l": 1,
    "c": "#757575",
    "t": 5
  }, {
    "p": [359, 9, -184],
    "s": [2, 1, 2],
    "l": 1,
    "c": "#757575",
    "t": 5
  }, {
    "p": [333, 9, -184],
    "s": [2, 1, 2],
    "l": 1,
    "c": "#757575",
    "t": 5
  }, {
    "p": [333, 26, -184],
    "s": [2, 1, 2],
    "l": 1,
    "c": "#757575",
    "t": 5
  }, {
    "p": [359, 26, -184],
    "s": [2, 1, 2],
    "l": 1,
    "c": "#757575",
    "t": 5
  }, {
    "p": [383, 2, -189],
    "s": [15, 1, 15],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [352, 2, -192],
    "s": [47, 1, 21],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [336, 2, -215],
    "s": [15, 1, 25],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [353, 2, -206],
    "s": [19, 1, 7],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [329, 2, -236],
    "s": [20, 1, 17],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [389, 3, -188],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -1.22, -3.14],
    "c": "#85aa6c"
  }, {
    "p": [333, 3, -187],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#85aa6c"
  }, {
    "p": [322, 0, -205],
    "s": [18, 29, 21],
    "c": "#595959",
    "e": "#11110c"
  }, {
    "p": [310, 0, -224],
    "s": [38, 57, 32],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [305, 0, -204],
    "s": [38, 50, 32],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [309, 66, -183],
    "s": [40, 2, 36],
    "c": "#8e8e8e",
    "e": "#11110c",
    "t": 8,
    "bo": 1
  }, {
    "p": [305, 50, -204],
    "s": [38, 2, 32],
    "c": "#8e8e8e",
    "e": "#11110c",
    "t": 8,
    "bo": 1
  }, {
    "p": [310, 57, -224],
    "s": [38, 2, 32],
    "c": "#8e8e8e",
    "e": "#11110c",
    "t": 8,
    "bo": 1
  }, {
    "p": [322, 29, -205],
    "s": [18, 2, 21],
    "c": "#8e8e8e",
    "e": "#11110c",
    "t": 8
  }, {
    "p": [332, 3, -219],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.4, 0],
    "c": "#85aa6c"
  }, {
    "p": [340, 8, -3],
    "s": [8, 34, 7],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [432, 8, -3],
    "s": [8, 34, 7],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [386, 8, -5],
    "s": [8, 34, 3],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [386, 8, -177],
    "s": [8, 34, 3],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [331, 45, -10],
    "s": [4, 11, 4],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [331, 45, -54],
    "s": [4, 11, 4],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [335, 49, -32],
    "s": [1, 7, 55],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [333, 8, -133],
    "s": [7, 35, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [333, 8, -94],
    "s": [7, 34, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [419, 41, -91],
    "s": [4, 8, 142],
    "c": "#707070",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [386, 41, -22],
    "s": [62, 8, 4],
    "c": "#707070",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [353, 41, -79],
    "s": [4, 8, 118],
    "c": "#707070",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [400, 41, -160],
    "s": [34, 8, 4],
    "c": "#707070",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [347, 56, -76],
    "s": [36, 5, 142],
    "c": "#8c8c8c",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [386, 56, -152],
    "s": [42, 5, 18],
    "c": "#8c8c8c",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [386, 56, -23],
    "s": [42, 5, 36],
    "c": "#8c8c8c",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [386, 57, -67],
    "s": [12, 4, 12],
    "c": "#e1e1e1",
    "e": "#18180a"
  }, {
    "p": [188, 11, -221],
    "s": [26, 53, 26],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [188, 13, -221],
    "s": [28, 7, 28],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [200, 11, -209],
    "s": [6, 53, 6],
    "c": "#6e6e6e",
    "e": "#18180a",
    "t": 5
  }, {
    "p": [200, 11, -233],
    "s": [6, 53, 6],
    "c": "#6e6e6e",
    "e": "#18180a",
    "t": 5
  }, {
    "p": [176, 11, -233],
    "s": [6, 53, 6],
    "c": "#6e6e6e",
    "e": "#18180a",
    "t": 5
  }, {
    "p": [176, 11, -209],
    "s": [6, 53, 6],
    "c": "#6e6e6e",
    "e": "#18180a",
    "t": 5
  }, {
    "p": [188, 64, -221],
    "s": [32, 4, 32],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [188, 72, -221],
    "s": [32, 4, 32],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [188, 68, -221],
    "s": [30, 4, 30],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [171, 14, -215],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.88, 0],
    "c": "#85aa6c"
  }, {
    "p": [283, 13, -193],
    "s": [16, 1, 28],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [277, 13, -172],
    "s": [25, 1, 14],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [260, 13, -169],
    "s": [9, 1, 8],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [270, 13, -213],
    "s": [37, 1, 12],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [241, 13, -220],
    "s": [21, 1, 19],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [204, 13, -211],
    "s": [23, 1, 18],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [272, 13, -202],
    "s": [6, 1, 10],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [180, 13, -211],
    "s": [25, 1, 24],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [193, 13, -231],
    "s": [45, 1, 16],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [166, 13, -209],
    "s": [3, 1, 16],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [183, 13, -197],
    "s": [13, 1, 4],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [185, 13, -249],
    "s": [15, 1, 20],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [199, 13, -242],
    "s": [13, 1, 6],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [186, 13, -261],
    "s": [9, 1, 4],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [256, 14, -214],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.18, 0],
    "c": "#85aa6c"
  }, {
    "p": [282, 14, -212],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.69, 0],
    "c": "#85aa6c"
  }, {
    "p": [286, 14, -170],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.71, 0],
    "c": "#85aa6c"
  }, {
    "p": [264, 14, -169],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -1.38, -3.14],
    "c": "#85aa6c"
  }, {
    "p": [186, -47, 75],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#4c663e"
  }, {
    "p": [213, -40, 126],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#4c663e"
  }, {
    "p": [99, -20, 65],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#4c663e"
  }, {
    "p": [318, -13, 75],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.35, 0],
    "c": "#4c663e"
  }, {
    "p": [266, 13, -213],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "c": "#4c663e"
  }, {
    "p": [73, -2, -458],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [-3.14, 0.53, 3.14],
    "c": "#4c663e"
  }, {
    "p": [22, -23, -31],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, 1.4, 0],
    "c": "#4c663e"
  }, {
    "p": [44, -31, 85],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#4c663e"
  }, {
    "p": [-2, -42, 85],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "c": "#4c663e"
  }, {
    "p": [22, 0, -32],
    "s": [6, 49, 6],
    "v": 1,
    "c": "#6e6e6e",
    "e": "#18180a",
    "t": 5
  }, {
    "p": [22, 0, -32],
    "s": [7, 49, 7],
    "v": 1,
    "c": "#6e6e6e",
    "e": "#18180a",
    "t": 5,
    "bo": 1
  }, {
    "p": [208, 0, -119],
    "s": [8, 34, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [76, 0, -119],
    "s": [8, 34, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [76, 0, -213],
    "s": [8, 34, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [126, 0, -171],
    "s": [8, 34, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [134, 0, -163],
    "s": [8, 34, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [208, 0, -163],
    "s": [8, 34, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [143, 0, -119],
    "s": [8, 34, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [142, 0, -119],
    "s": [127, 12, 6],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [142, 25, -119],
    "s": [127, 9, 6],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [142, 12, -119],
    "s": [127, 2, 7],
    "c": "#707070",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [142, 23, -119],
    "s": [127, 2, 7],
    "c": "#707070",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [142, 9, -122],
    "s": [127, 15, 1],
    "c": "#707070",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [110, 14, -119],
    "s": [3, 9, 3],
    "c": "#c5c5c5",
    "e": "#18180a"
  }, {
    "p": [135, 14, -119],
    "s": [3, 9, 3],
    "c": "#c5c5c5",
    "e": "#18180a"
  }, {
    "p": [84, 14, -119],
    "s": [3, 9, 3],
    "c": "#c5c5c5",
    "e": "#18180a"
  }, {
    "p": [96, 14, -119],
    "s": [3, 9, 3],
    "c": "#c5c5c5",
    "e": "#18180a"
  }, {
    "p": [123, 14, -119],
    "s": [3, 9, 3],
    "c": "#c5c5c5",
    "e": "#18180a"
  }, {
    "p": [151, 14, -119],
    "s": [3, 9, 3],
    "c": "#c5c5c5",
    "e": "#18180a"
  }, {
    "p": [200, 14, -119],
    "s": [3, 9, 3],
    "c": "#c5c5c5",
    "e": "#18180a"
  }, {
    "p": [176, 14, -119],
    "s": [3, 9, 3],
    "c": "#c5c5c5",
    "e": "#18180a"
  }, {
    "p": [163, 14, -119],
    "s": [3, 9, 3],
    "c": "#c5c5c5",
    "e": "#18180a"
  }, {
    "p": [188, 14, -119],
    "s": [3, 9, 3],
    "c": "#c5c5c5",
    "e": "#18180a"
  }, {
    "p": [142, 34, -141],
    "s": [140, 4, 52],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [142, 38, -141],
    "s": [136, 4, 48],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [142, 42, -141],
    "s": [140, 4, 52],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [7, 2, -214],
    "s": [24, 1, 28],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [17, 2, -237],
    "s": [34, 1, 18],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [6, 2, -60],
    "s": [13, 1, 18],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [16, 2, -56],
    "s": [7, 1, 10],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [3, 2, -111],
    "s": [10, 1, 8],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-5, 2, -118],
    "s": [26, 1, 6],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-25, 2, -116],
    "s": [14, 1, 13],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-13, 2, -123],
    "s": [10, 1, 4],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-69, 2, -128],
    "s": [21, 1, 25],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-72, 2, -159],
    "s": [17, 1, 37],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-62, 2, -150],
    "s": [3, 1, 19],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-17, 2, -212],
    "s": [24, 1, 17],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-76, 2, -212],
    "s": [22, 1, 39],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-74, 2, -185],
    "s": [10, 1, 15],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [61, 2, -124],
    "s": [3, 1, 22],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [16, 2, -175],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [28, 2, -175],
    "s": [12, 12, 12],
    "i": 8,
    "r": [0, 1.57, 0]
  }, {
    "p": [22, 8, -175],
    "s": [24, 7, 12],
    "l": 1,
    "c": "#3964a2",
    "t": 5,
    "ab": 1
  }, {
    "p": [69, 3, -153],
    "s": [1, 18, 5],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#c8c8c8",
    "t": 2
  }, {
    "p": [69, 3, -145],
    "s": [1, 18, 5],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#c8c8c8",
    "t": 2
  }, {
    "p": [-49, 54, -258],
    "s": [48, 7, 96],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-4, 0, -113],
    "s": [8, 38, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-2, 0, -93],
    "s": [2, 38, 4],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-38, 46, -74],
    "s": [76, 4, 86],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-39, 42, -75],
    "s": [74, 4, 80],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [-38, 50, -76],
    "s": [42, 13, 50],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-38, 63, -76],
    "s": [44, 4, 52],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-38, 67, -76],
    "s": [41, 4, 48],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [-38, 71, -76],
    "s": [44, 4, 52],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-16, 0, -116],
    "s": [20, 12, 1],
    "c": "#696969",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [-19, 50, -99],
    "s": [6, 13, 6],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-57, 50, -99],
    "s": [6, 13, 6],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-19, 50, -53],
    "s": [6, 13, 6],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-57, 50, -53],
    "s": [6, 13, 6],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-30, -34, 6],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#4c663e"
  }, {
    "p": [-2, -24, 41],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -1.22, 0],
    "c": "#4c663e"
  }, {
    "p": [68, 0, -274],
    "s": [122, 61, 64],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-86, 0, -154],
    "s": [28, 37, 36],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [-89, 0, -130],
    "s": [28, 53, 38],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [-93, 0, -178],
    "s": [28, 46, 38],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [-91, 0, -203],
    "s": [28, 41, 27],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [-86, 37, -154],
    "s": [28, 2, 36],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [-93, 46, -178],
    "s": [28, 2, 38],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [-91, 41, -203],
    "s": [28, 2, 27],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [-89, 53, -130],
    "s": [28, 2, 38],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [4, 3, -112],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.88, 0],
    "c": "#85aa6c"
  }, {
    "p": [4, 3, -63],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.39, 0],
    "c": "#85aa6c"
  }, {
    "p": [-70, 3, -121],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.71, 0],
    "c": "#85aa6c"
  }, {
    "p": [-71, 3, -133],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.51, 0],
    "c": "#85aa6c"
  }, {
    "p": [-76, 3, -176],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.21, 0],
    "c": "#85aa6c"
  }, {
    "p": [-72, 3, -205],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.88, -3.14],
    "c": "#85aa6c"
  }, {
    "p": [69, 3, -126],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -1.04, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [-148, -23, -143],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [-3.14, -1.23, -3.14],
    "c": "#4c663e"
  }, {
    "p": [-148, -35, -209],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [-3.14, -0.71, -3.14],
    "c": "#4c663e"
  }, {
    "p": [-148, -25, -83],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -1.04, 0],
    "c": "#4c663e"
  }, {
    "p": [-87, -25, -9],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -1.56, 0],
    "c": "#4c663e"
  }, {
    "p": [103, -36, 128],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#4c663e"
  }, {
    "p": [19, 52, -450],
    "s": [1, 28, 1],
    "l": 1,
    "c": "#8e8e8e",
    "t": 2
  }, {
    "p": [-50, 50, -116],
    "s": [2, 2, 20],
    "c": "#c8c8c8",
    "t": 2,
    "bo": 1
  }, {
    "p": [-50, 41, -115],
    "s": [1, 13, 2],
    "l": 1,
    "r": [-0.7, 0, 0],
    "c": "#c8c8c8",
    "t": 2
  }, {
    "p": [6, 2, -53],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [6, 2, -41],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [70, 46, -138],
    "s": [21, 2, 2],
    "c": "#c8c8c8",
    "t": 2,
    "bo": 1
  }, {
    "p": [74, 37, -138],
    "s": [2, 13, 1],
    "l": 1,
    "r": [0, 0, 0.7],
    "c": "#c8c8c8",
    "t": 2
  }, {
    "p": [61, 23, -138],
    "s": [1, 23, 1],
    "l": 1,
    "c": "#8e8e8e",
    "t": 2
  }, {
    "p": [-124, -12, -42],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [-3.14, -0.71, -3.14],
    "c": "#4c663e"
  }, {
    "p": [-9, 0, -258],
    "s": [32, 61, 96],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [68, 0, -242],
    "s": [122, 34, 4],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-22, 0, -213],
    "s": [8, 46, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-76, 0, -213],
    "s": [8, 46, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-49, 46, -213],
    "s": [62, 8, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-49, 46, -303],
    "s": [62, 8, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-76, 0, -303],
    "s": [8, 46, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-22, 0, -303],
    "s": [8, 46, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [4, 0, -213],
    "s": [8, 61, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [126, 0, -208],
    "s": [8, 34, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [101, 42, -188],
    "s": [58, 4, 42],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [126, 0, -245],
    "s": [8, 61, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [126, 13, -303],
    "s": [8, 48, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-102, 13, -303],
    "s": [8, 48, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-102, 0, -213],
    "s": [8, 61, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [69, 34, -225],
    "s": [122, 4, 32],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [69, 42, -225],
    "s": [122, 4, 32],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [68, 38, -227],
    "s": [120, 4, 32],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [-49, 61, -258],
    "s": [114, 4, 98],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-48, 65, -258],
    "s": [112, 4, 94],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [-49, 69, -258],
    "s": [114, 4, 98],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [69, 61, -274],
    "s": [122, 4, 66],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [69, 69, -274],
    "s": [122, 4, 66],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [68, 65, -274],
    "s": [120, 4, 62],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [-9, 0, -258],
    "s": [33, 12, 97],
    "c": "#696969",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [171, 0, -163],
    "s": [8, 34, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [101, 38, -188],
    "s": [54, 4, 46],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [101, 34, -188],
    "s": [58, 4, 42],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [76, 0, -163],
    "s": [8, 34, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-49, 47, -295],
    "s": [48, 7, 8],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-69, 47, -258],
    "s": [8, 8, 66],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-49, 47, -221],
    "s": [48, 7, 8],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-29, 47, -258],
    "s": [8, 8, 66],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-49, 52, -258],
    "s": [33, 7, 67],
    "c": "#8c8c8c",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [-49, 2, -241],
    "s": [48, 11, 58],
    "i": 9,
    "c": "#9d9d9d",
    "t": 1,
    "d": 3
  }, {
    "p": [-77, 36, -248],
    "s": [8, 14, 5],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-77, 36, -228],
    "s": [8, 14, 5],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-77, 36, -288],
    "s": [8, 14, 5],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-77, 36, -268],
    "s": [8, 14, 5],
    "l": 1,
    "r": [0, 0, -0.35],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-21, 36, -228],
    "s": [8, 14, 5],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-21, 36, -288],
    "s": [8, 14, 5],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-21, 36, -268],
    "s": [8, 14, 5],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-21, 36, -248],
    "s": [8, 14, 5],
    "l": 1,
    "r": [0, 0, 0.35],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-76, 0, -228],
    "s": [8, 38, 5],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-76, 0, -248],
    "s": [8, 38, 5],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-76, 0, -268],
    "s": [8, 38, 5],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-76, 0, -288],
    "s": [8, 38, 5],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-22, 0, -228],
    "s": [8, 38, 5],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-22, 0, -248],
    "s": [8, 38, 5],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-22, 0, -268],
    "s": [8, 38, 5],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-22, 0, -288],
    "s": [8, 38, 5],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-22, 36, -228],
    "s": [9, 2, 6],
    "c": "#8c8c8c",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-22, 36, -248],
    "s": [9, 2, 6],
    "c": "#8c8c8c",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-22, 36, -268],
    "s": [9, 2, 6],
    "c": "#8c8c8c",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-22, 36, -288],
    "s": [9, 2, 6],
    "c": "#8c8c8c",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-73, 36, -288],
    "s": [3, 2, 6],
    "c": "#8c8c8c",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-73, 36, -268],
    "s": [3, 2, 6],
    "c": "#8c8c8c",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-73, 36, -248],
    "s": [3, 2, 6],
    "c": "#8c8c8c",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-73, 36, -228],
    "s": [3, 2, 6],
    "c": "#8c8c8c",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-49, 51, -288],
    "s": [32, 1, 6],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-49, 51, -228],
    "s": [32, 1, 6],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-36, 51, -258],
    "s": [6, 1, 54],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-62, 51, -258],
    "s": [6, 1, 54],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [170, 13, -163],
    "s": [33, 1, 24],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [194, 13, -169],
    "s": [15, 1, 6],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [149, 13, -163],
    "s": [9, 1, 21],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [134, 13, -163],
    "s": [21, 1, 41],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [130, 13, -200],
    "s": [21, 1, 33],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [126, 13, -224],
    "s": [21, 1, 15],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [129, 13, -245],
    "s": [21, 1, 27],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [165, 13, -176],
    "s": [14, 1, 2],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [205, 13, -167],
    "s": [7, 1, 5],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [129, 13, -269],
    "s": [18, 1, 21],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [129, 13, -290],
    "s": [21, 1, 21],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [129, 13, -308],
    "s": [29, 1, 15],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [141, 13, -247],
    "s": [3, 1, 18],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [135, 13, -317],
    "s": [13, 1, 3],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [104, 13, -313],
    "s": [21, 1, 18],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [86, 13, -311],
    "s": [15, 1, 26],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [69, 13, -313],
    "s": [19, 1, 15],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [36, 13, -308],
    "s": [21, 1, 27],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [53, 13, -310],
    "s": [13, 1, 8],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [15, 13, -318],
    "s": [21, 1, 13],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-10, 13, -310],
    "s": [11, 1, 22],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-24, 13, -303],
    "s": [17, 1, 16],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-21, 13, -313],
    "s": [11, 1, 4],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-27, 13, -289],
    "s": [4, 1, 12],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-81, 13, -311],
    "s": [27, 1, 11],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-74, 13, -299],
    "s": [19, 1, 13],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-74, 13, -290],
    "s": [12, 1, 5],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [13, 3, -234],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.71, 0],
    "c": "#85aa6c"
  }, {
    "p": [-85, 14, -311],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.41, 0],
    "c": "#85aa6c"
  }, {
    "p": [-15, 14, -311],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.89, 0],
    "c": "#85aa6c"
  }, {
    "p": [131, 14, -310],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -1.2, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [134, 14, -170],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.68, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [133, 14, -181],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.07, 0],
    "c": "#85aa6c"
  }, {
    "p": [179, 14, -170],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, 0.19, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [133, 14, -252],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -1.2, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [246, 32, -221],
    "s": [90, 2, 5],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [187, 32, -238],
    "s": [5, 2, 10],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [187, 32, -299],
    "s": [5, 2, 32],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [187, 32, -351],
    "s": [5, 2, 10],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [188, 13, -279],
    "s": [11, 1, 10],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [187, 13, -299],
    "s": [17, 1, 30],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [187, 13, -319],
    "s": [13, 1, 10],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [177, 13, -295],
    "s": [3, 1, 14],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [188, 13, -326],
    "s": [7, 1, 4],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [187, 13, -347],
    "s": [12, 1, 18],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [173, 13, -351],
    "s": [16, 1, 13],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [195, 13, -351],
    "s": [4, 1, 10],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [61, 42, -242],
    "s": [121, 4, 2],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [52, 13, -303],
    "s": [8, 48, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [15, 12, -316],
    "s": [53, 8, 3],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [15, 20, -316],
    "s": [54, 2, 4],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [-10, 12, -310],
    "s": [3, 8, 9],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [40, 12, -310],
    "s": [3, 8, 9],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-10, 20, -310],
    "s": [4, 2, 8],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [40, 20, -310],
    "s": [4, 2, 8],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [0, 13, -312],
    "s": [9, 1, 22],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [15, 12, -310],
    "s": [51, 4, 9],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [59, 14, -310],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -1.03, -3.14],
    "c": "#85aa6c"
  }, {
    "p": [89, 12, -316],
    "s": [53, 8, 3],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [89, 20, -316],
    "s": [54, 2, 4],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [64, 12, -310],
    "s": [3, 8, 9],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [114, 12, -310],
    "s": [3, 8, 9],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [64, 20, -310],
    "s": [4, 2, 8],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [114, 20, -310],
    "s": [4, 2, 8],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [89, 12, -310],
    "s": [51, 4, 9],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [117, 13, -318],
    "s": [5, 1, 5],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [45, 14, -310],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.06, 0],
    "c": "#85aa6c"
  }, {
    "p": [0, 13, -303],
    "s": [4, 33, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [30, 13, -303],
    "s": [4, 33, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [15, 46, -303],
    "s": [37, 4, 9],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [74, 13, -303],
    "s": [4, 33, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [104, 13, -303],
    "s": [4, 33, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [89, 46, -303],
    "s": [37, 4, 9],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [132, 73, -289],
    "s": [17, 2, 2],
    "c": "#c8c8c8",
    "t": 2,
    "bo": 1
  }, {
    "p": [128, 65, -289],
    "s": [2, 12, 1],
    "l": 1,
    "r": [0, 0, -0.7],
    "c": "#c8c8c8",
    "t": 2
  }, {
    "p": [139, 42, -289],
    "s": [1, 31, 1],
    "l": 1,
    "c": "#8e8e8e",
    "t": 2
  }, {
    "p": [133, 12, -269],
    "s": [1, 18, 4],
    "l": 1,
    "r": [0, 0, 0.18],
    "c": "#c8c8c8",
    "t": 2
  }, {
    "p": [133, 12, -261],
    "s": [1, 18, 4],
    "l": 1,
    "r": [0, 0, 0.18],
    "c": "#c8c8c8",
    "t": 2
  }, {
    "p": [-94, 13, -366],
    "s": [8, 45, 8],
    "c": "#6e6e6e",
    "e": "#18180a",
    "t": 5,
    "bo": 1
  }, {
    "p": [-94, 52, -338],
    "s": [7, 4, 48],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-94, 43, -339],
    "s": [7, 4, 50],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-94, 47, -338],
    "s": [4, 5, 50],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [-91, 13, -326],
    "s": [7, 39, 6],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-91, 13, -348],
    "s": [7, 39, 6],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-94, 13, -310],
    "s": [8, 45, 8],
    "c": "#6e6e6e",
    "e": "#18180a",
    "t": 5,
    "bo": 1
  }, {
    "p": [-94, 13, -339],
    "s": [4, 32, 52],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-87, 13, -326],
    "s": [11, 1, 19],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-86, 13, -344],
    "s": [13, 1, 17],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-87, 13, -358],
    "s": [11, 1, 11],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-84, 13, -373],
    "s": [16, 1, 19],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-84, 13, -394],
    "s": [20, 1, 23],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-79, 13, -320],
    "s": [5, 1, 7],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-88, 14, -356],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.68, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [-133, -8, -326],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -1.04, 0],
    "c": "#4c663e"
  }, {
    "p": [-183, -20, -357],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [3.14, -0.88, 3.14],
    "c": "#4c663e"
  }, {
    "p": [-174, -9, -245],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [3.14, 0.17, 3.14],
    "c": "#4c663e"
  }, {
    "p": [-174, -30, -295],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [3.14, 0.87, 3.14],
    "c": "#4c663e"
  }, {
    "p": [-5, 23, -400],
    "s": [69, 2, 5],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [-42, 23, -410],
    "s": [5, 2, 25],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [32, 23, -432],
    "s": [5, 2, 69],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [-5, 13, -431],
    "s": [79, 7, 67],
    "c": "#696969",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [230, 13, -216],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-83, 13, -373],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-86, 14, -365],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -1.38, 3.13],
    "c": "#85aa6c"
  }, {
    "p": [-139, 13, -373],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-83, 13, -481],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-83, 13, -523],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-83, 13, -425],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-3, 13, -465],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [83, 13, -465],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [83, 13, -523],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-3, 13, -523],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-111, 67, -448],
    "s": [64, 4, 158],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-111, 0, -448],
    "s": [63, 20, 157],
    "c": "#696969",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [59, 0, -492],
    "s": [49, 20, 61],
    "c": "#696969",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [-111, 71, -448],
    "s": [60, 4, 154],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [-111, 75, -448],
    "s": [64, 4, 158],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-45, 49, -496],
    "s": [80, 4, 62],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-45, 53, -496],
    "s": [80, 4, 58],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [-45, 57, -496],
    "s": [80, 4, 62],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [40, 67, -494],
    "s": [94, 4, 66],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [40, 75, -494],
    "s": [94, 4, 66],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [40, 71, -494],
    "s": [90, 4, 62],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [40, 13, -465],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-17, 21, -472],
    "s": [9, 4, 9],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-17, 45, -472],
    "s": [9, 4, 9],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-70, 21, -472],
    "s": [9, 4, 9],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-70, 45, -472],
    "s": [9, 4, 9],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-43, 21, -472],
    "s": [9, 4, 9],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [-43, 45, -472],
    "s": [9, 4, 9],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-68, -8, -546],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, 0.71, 0],
    "c": "#4c663e"
  }, {
    "p": [-19, -18, -547],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [3.14, -1.23, 3.14],
    "c": "#4c663e"
  }, {
    "p": [19, 79, -459],
    "s": [2, 2, 21],
    "c": "#c8c8c8",
    "t": 2,
    "bo": 1
  }, {
    "p": [19, 71, -463],
    "s": [1, 14, 2],
    "l": 1,
    "r": [0.87, 0, 0],
    "c": "#c8c8c8",
    "t": 2
  }, {
    "p": [-50, 29, -124],
    "s": [1, 21, 1],
    "l": 1,
    "c": "#8e8e8e",
    "t": 2
  }, {
    "p": [-75, 46, -399],
    "s": [9, 1, 26],
    "pe": 1,
    "c": "#c8c8c8",
    "t": 2
  }, {
    "p": [-75, 47, -387],
    "s": [1, 40, 1],
    "l": 1,
    "c": "#8e8e8e",
    "t": 2
  }, {
    "p": [-75, 47, -411],
    "s": [1, 39, 1],
    "l": 1,
    "c": "#8e8e8e",
    "t": 2
  }, {
    "p": [-73, 47, -393],
    "s": [5, 1, 5],
    "l": 1,
    "c": "#5f3232",
    "t": 5
  }, {
    "p": [-70, 43, -393],
    "s": [1, 5, 5],
    "l": 1,
    "c": "#5f3232",
    "t": 5
  }, {
    "p": [-84, 86, -411],
    "s": [22, 2, 2],
    "c": "#c8c8c8",
    "t": 2,
    "bo": 1
  }, {
    "p": [-94, 79, -411],
    "s": [2, 7, 2],
    "c": "#c8c8c8",
    "t": 2
  }, {
    "p": [-94, 79, -387],
    "s": [2, 7, 2],
    "c": "#c8c8c8",
    "t": 2
  }, {
    "p": [-84, 86, -387],
    "s": [22, 2, 2],
    "c": "#c8c8c8",
    "t": 2,
    "bo": 1
  }, {
    "p": [-94, 79, -387],
    "s": [2, 16, 1],
    "l": 1,
    "r": [0, 0, -1.05],
    "c": "#c8c8c8",
    "t": 2
  }, {
    "p": [-94, 79, -411],
    "s": [2, 16, 1],
    "l": 1,
    "r": [0, 0, -1.05],
    "c": "#c8c8c8",
    "t": 2
  }, {
    "p": [7, 21, -454],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [7, 33, -454],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-32, 21, -410],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [-20, 21, -410],
    "s": [12, 12, 12],
    "i": 8,
    "r": [0, 1.57, 0]
  }, {
    "p": [-26, 27, -410],
    "s": [24, 7, 12],
    "l": 1,
    "c": "#3964a2",
    "t": 5,
    "ab": 1
  }, {
    "p": [242, 13, -296],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [75, 13, -444],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-65, 21, -474],
    "s": [44, 1, 31],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-34, 21, -474],
    "s": [18, 1, 21],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [8, 21, -474],
    "s": [46, 1, 39],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-20, 21, -474],
    "s": [10, 1, 30],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [24, 21, -445],
    "s": [12, 1, 19],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [26, 21, -430],
    "s": [9, 1, 11],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [26, 21, -418],
    "s": [11, 1, 13],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [17, 21, -406],
    "s": [27, 1, 11],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-2, 21, -406],
    "s": [11, 1, 8],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-24, 21, -411],
    "s": [33, 1, 18],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-19, 21, -422],
    "s": [14, 1, 4],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [15, 21, -415],
    "s": [11, 1, 7],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [6, 21, -450],
    "s": [24, 1, 9],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-75, 21, -448],
    "s": [12, 1, 21],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-64, 21, -455],
    "s": [10, 1, 7],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-77, 21, -432],
    "s": [6, 1, 11],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-35, 13, -404],
    "s": [30, 1, 23],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-7, 13, -404],
    "s": [26, 1, 29],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [23, 13, -406],
    "s": [34, 1, 29],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [39, 13, -431],
    "s": [12, 1, 21],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [42, 13, -452],
    "s": [16, 1, 21],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [30, 13, -390],
    "s": [14, 1, 3],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [56, 13, -460],
    "s": [12, 1, 12],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [71, 13, -452],
    "s": [18, 1, 33],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [79, 13, -419],
    "s": [21, 1, 33],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [80, 13, -392],
    "s": [11, 1, 21],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [74, 13, -372],
    "s": [19, 1, 20],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [92, 13, -446],
    "s": [28, 39, 36],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [96, 13, -416],
    "s": [28, 34, 29],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [97, 13, -379],
    "s": [36, 44, 46],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [124, 13, -375],
    "s": [35, 36, 31],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [158, 13, -373],
    "s": [40, 41, 31],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [143, 13, -370],
    "s": [23, 29, 33],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [186, -9, -373],
    "s": [26, 58, 34],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [188, -9, -401],
    "s": [26, 50, 27],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [178, -9, -431],
    "s": [34, 56, 40],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [199, -9, -468],
    "s": [49, 50, 40],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [239, -9, -470],
    "s": [31, 42, 40],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [226, -9, -464],
    "s": [25, 35, 40],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [158, 11, -323],
    "s": [58, 2, 74],
    "c": "#9d9d9d",
    "t": 1
  }, {
    "p": [97, 57, -379],
    "s": [36, 2, 46],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [96, 47, -416],
    "s": [28, 2, 29],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [92, 52, -446],
    "s": [28, 2, 36],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [124, 49, -375],
    "s": [35, 2, 31],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [158, 54, -373],
    "s": [40, 2, 31],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1,
    "ab": 1
  }, {
    "p": [145, 13, -356],
    "s": [40, 1, 14],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [99, 13, -354],
    "s": [52, 1, 16],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [108, 13, -345],
    "s": [25, 1, 2],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [143, 42, -370],
    "s": [23, 2, 33],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [186, 49, -373],
    "s": [26, 2, 34],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [-61, 22, -474],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.85, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [-75, 22, -463],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.16, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [-35, 22, -473],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.15, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [-26, 22, -474],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, 0.37, -3.14],
    "c": "#85aa6c"
  }, {
    "p": [-9, 22, -473],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, 0.55, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [17, 22, -459],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, 1.07, -3.14],
    "c": "#85aa6c"
  }, {
    "p": [24, 22, -408],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.02, 0],
    "c": "#85aa6c"
  }, {
    "p": [-8, 22, -408],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.42, -3.14],
    "c": "#85aa6c"
  }, {
    "p": [40, 14, -456],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, 0.37, -3.14],
    "c": "#85aa6c"
  }, {
    "p": [74, 14, -436],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.33, -3.14],
    "c": "#85aa6c"
  }, {
    "p": [77, 14, -406],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, 0.37, -3.14],
    "c": "#85aa6c"
  }, {
    "p": [127, 14, -356],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.33, -3.14],
    "c": "#85aa6c"
  }, {
    "p": [180, 14, -352],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, 0.37, -3.14],
    "c": "#85aa6c"
  }, {
    "p": [266, 13, -213],
    "s": [7, 57, 7],
    "v": 1,
    "e": "#18180a"
  }, {
    "p": [266, 13, -213],
    "s": [8, 57, 8],
    "v": 1,
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [72, 13, -458],
    "s": [6, 41, 6],
    "v": 1,
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [72, 13, -458],
    "s": [7, 41, 7],
    "v": 1,
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [264, 13, -228],
    "s": [25, 1, 10],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [285, 13, -230],
    "s": [17, 1, 15],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [266, -9, -480],
    "s": [35, 59, 46],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [188, 41, -401],
    "s": [26, 2, 27],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [178, 47, -431],
    "s": [34, 2, 40],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [199, 41, -468],
    "s": [49, 2, 40],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [128, -22, -447],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [3.14, 0, 3.14],
    "c": "#4c663e"
  }, {
    "p": [130, -27, -487],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [-3.13, 1.4, 3.13],
    "c": "#4c663e"
  }, {
    "p": [181, -4, -498],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, 0.34, 0],
    "c": "#4c663e"
  }, {
    "p": [223, -39, -513],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -1.41, 0],
    "c": "#4c663e"
  }, {
    "p": [262, -28, -574],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.36, 0],
    "c": "#4c663e"
  }, {
    "p": [169, -36, -547],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -1.23, 0],
    "c": "#4c663e"
  }, {
    "p": [135, -37, -522],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [-3.14, 1.41, -3.14],
    "c": "#4c663e"
  }, {
    "p": [226, 26, -464],
    "s": [25, 2, 40],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [239, 33, -470],
    "s": [31, 2, 40],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [266, 50, -480],
    "s": [35, 2, 46],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [386, 0, -180],
    "s": [8, 56, 6],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-43, 0, -472],
    "s": [8, 45, 8],
    "c": "#707070",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [-17, 0, -472],
    "s": [8, 45, 8],
    "c": "#707070",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [-70, 0, -472],
    "s": [8, 45, 8],
    "c": "#707070",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [-38, 59, -50],
    "s": [18, 1, 6],
    "i": 30,
    "r": [1.57, 0, 0],
    "st": "Map By CrispyCrust",
    "sb": "#ffffff",
    "bv": 1,
    "sf": 74,
    "sa": 1
  }, {
    "p": [103, 13, -354],
    "s": [4, 37, 4],
    "c": "#939393",
    "t": 2,
    "bo": 1
  }, {
    "p": [89, 13, -354],
    "s": [4, 37, 4],
    "c": "#939393",
    "t": 2,
    "bo": 1
  }, {
    "p": [89, 50, -331],
    "s": [4, 2, 50],
    "c": "#939393",
    "t": 2,
    "bo": 1
  }, {
    "p": [103, 50, -331],
    "s": [4, 2, 50],
    "c": "#939393",
    "t": 2,
    "bo": 1
  }, {
    "p": [96, 52, -319],
    "s": [17, 1, 15],
    "pe": 1,
    "c": "#414f91",
    "t": 5,
    "bo": 1
  }, {
    "p": [87, 43, -319],
    "s": [1, 10, 15],
    "pe": 1,
    "c": "#414f91",
    "t": 5,
    "bo": 1
  }, {
    "p": [105, 45, -319],
    "s": [1, 8, 15],
    "pe": 1,
    "c": "#414f91",
    "t": 5,
    "bo": 1
  }, {
    "p": [89, 41, -353],
    "s": [2, 16, 2],
    "l": 1,
    "r": [0.87, 0, 0],
    "c": "#939393",
    "t": 2
  }, {
    "p": [103, 41, -353],
    "s": [2, 16, 2],
    "l": 1,
    "r": [0.87, 0, 0],
    "c": "#939393",
    "t": 2
  }, {
    "p": [240, 28, -221],
    "s": [14, 4, 4],
    "e": "#18180a"
  }, {
    "p": [217, 13, -221],
    "s": [32, 19, 4],
    "e": "#18180a"
  }, {
    "p": [270, 13, -221],
    "s": [46, 19, 4],
    "e": "#18180a"
  }, {
    "p": [333, 47, -116],
    "s": [5, 9, 51],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [293, 0, -111],
    "s": [76, 38, 110],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [309, 0, -183],
    "s": [40, 66, 36],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [295, 38, -55],
    "s": [70, 4, 4],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [334, 8, -133],
    "s": [3, 34, 70],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [340, 2, -111],
    "s": [1, 23, 5],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": "#a7a7a7",
    "t": 2
  }, {
    "p": [363, 0, -177],
    "s": [55, 8, 4],
    "c": "#696969",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [411, 0, -5],
    "s": [148, 8, 4],
    "c": "#696969",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [333, 0, -9],
    "s": [8, 8, 7],
    "c": "#696969",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [358, 0, -181],
    "s": [49, 12, 2],
    "c": "#696969",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [414, 35, -179],
    "s": [32, 21, 5],
    "c": "#ffffff",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [135, -15, -411],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.18, 0],
    "c": "#4c663e"
  }, {
    "p": [167, -14, -472],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#4c663e"
  }, {
    "p": [125, 34, -391],
    "s": [2, 8, 3],
    "c": "#939393",
    "t": 2
  }, {
    "p": [125, 34, -429],
    "s": [2, 8, 2],
    "c": "#939393",
    "t": 2
  }, {
    "p": [154, -38, -407],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, 1.39, 0],
    "c": "#4c663e"
  }, {
    "p": [96, 51, -354],
    "s": [10, 1, 2],
    "c": "#939393",
    "t": 2
  }, {
    "p": [96, 51, -308],
    "s": [10, 1, 2],
    "c": "#939393",
    "t": 2
  }, {
    "p": [96, 51, -330],
    "s": [10, 1, 2],
    "c": "#939393",
    "t": 2
  }, {
    "p": [96, 51, -318],
    "s": [10, 1, 2],
    "c": "#939393",
    "t": 2
  }, {
    "p": [96, 51, -342],
    "s": [10, 1, 2],
    "c": "#939393",
    "t": 2
  }, {
    "p": [15, 31, -303],
    "s": [5, 1, 9],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [15, 34, -303],
    "s": [5, 1, 9],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [12, 31, -303],
    "s": [1, 4, 9],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [18, 31, -303],
    "s": [1, 4, 9],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [15, 18, -308],
    "s": [5, 15, 1],
    "l": 1,
    "c": "#2787ca",
    "o": 0.7000000000000001,
    "t": 8,
    "ts": 5,
    "td": 1,
    "ab": 1
  }, {
    "p": [15, 16, -310],
    "s": [47, 2, 10],
    "l": 1,
    "c": "#2787ca",
    "o": 0.7000000000000001,
    "t": 8,
    "ts": -0.1,
    "td": 1,
    "ab": 1
  }, {
    "p": [89, 16, -310],
    "s": [47, 2, 10],
    "l": 1,
    "c": "#2787ca",
    "o": 0.7000000000000001,
    "t": 8,
    "ts": -0.1,
    "td": 1,
    "ab": 1
  }, {
    "p": [15, 32, -303],
    "s": [5, 2, 8],
    "c": "#000000",
    "e": "#18180a"
  }, {
    "p": [89, 31, -303],
    "s": [5, 1, 9],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [89, 34, -303],
    "s": [5, 1, 9],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [86, 31, -303],
    "s": [1, 4, 9],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [92, 31, -303],
    "s": [1, 4, 9],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [89, 18, -308],
    "s": [5, 15, 1],
    "l": 1,
    "c": "#2787ca",
    "o": 0.7000000000000001,
    "t": 8,
    "ts": 5,
    "td": 1,
    "ab": 1
  }, {
    "p": [89, 32, -303],
    "s": [5, 2, 8],
    "c": "#000000",
    "e": "#18180a"
  }, {
    "p": [386, 27, -116],
    "s": [10, 4, 6],
    "c": "#707070",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [389, 27, -121],
    "s": [4, 2, 4],
    "c": "#707070",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [386, 55, -118],
    "s": [10, 4, 10],
    "c": "#707070",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [386, 53, -115],
    "s": [10, 2, 4],
    "c": "#707070",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [87, 42, -339],
    "s": [1, 11, 22],
    "pe": 1,
    "c": "#612424",
    "t": 5,
    "bo": 1
  }, {
    "p": [105, 43, -339],
    "s": [1, 10, 22],
    "pe": 1,
    "c": "#612424",
    "t": 5,
    "bo": 1
  }, {
    "p": [96, 52, -339],
    "s": [17, 1, 22],
    "pe": 1,
    "c": "#612424",
    "t": 5,
    "bo": 1
  }, {
    "p": [411, 66, -170],
    "s": [52, 5, 26],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [373, 66, -162],
    "s": [24, 5, 10],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [412, 61, -167],
    "s": [46, 5, 28],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [376, 61, -159],
    "s": [26, 5, 12],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [400, 56, -169],
    "s": [14, 5, 16],
    "c": "#8c8c8c",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [371, 8, -179],
    "s": [26, 45, 5],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [347, 8, -179],
    "s": [22, 42, 5],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [332, 47, -160],
    "s": [7, 5, 37],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [338, 42, -163],
    "s": [8, 6, 28],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [373, 42, -174],
    "s": [24, 6, 6],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [349, 2, -159],
    "s": [4, 2, 6],
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#8c8c8c",
    "e": "#18180a"
  }, {
    "p": [374, 2, -159],
    "s": [7, 3, 5],
    "l": 1,
    "r": [0, 0.87, 0],
    "c": "#8c8c8c",
    "e": "#18180a"
  }, {
    "p": [398, 2, -74],
    "s": [4, 2, 5],
    "l": 1,
    "r": [-3.14, 0.17, -3.14],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [353, 2, -133],
    "s": [5, 3, 6],
    "l": 1,
    "r": [0, 0.52, 0],
    "c": "#707070",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [360, 56, -149],
    "s": [10, 5, 4],
    "c": "#8c8c8c",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [419, 2, -514],
    "s": [15, 14, 4],
    "e": "#18180a"
  }, {
    "p": [372, 0, -589],
    "s": [110, 10, 53],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [312, 16, -514],
    "s": [70, 2, 5],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [414, 16, -514],
    "s": [38, 2, 5],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [248, 0, -397],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [248, 0, -289],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [330, 0, -289],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [330, 0, -329],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [338, 0, -337],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [374, 0, -337],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [330, 0, -371],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [338, 0, -363],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [330, 0, -397],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [374, 0, -363],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [426, 0, -371],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [419, 0, -350],
    "s": [8, 54, 32],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [418, 0, -337],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [418, 0, -363],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [426, 0, -329],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [396, 41, -350],
    "s": [38, 13, 32],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [426, 0, -295],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [418, 0, -287],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [392, 0, -287],
    "s": [9, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [392, 0, -249],
    "s": [9, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [516, 0, -249],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [433, 0, -249],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [478, 0, -249],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [248, 0, -342],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [426, 0, -397],
    "s": [8, 54, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [452, -9, -410],
    "s": [26, 51, 34],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [450, -9, -438],
    "s": [28, 46, 32],
    "c": "#595959",
    "e": "#11110c",
    "bo": 1
  }, {
    "p": [450, 37, -438],
    "s": [28, 2, 32],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [452, 42, -410],
    "s": [26, 2, 34],
    "c": "#8e8e8e",
    "t": 8,
    "bo": 1
  }, {
    "p": [289, 54, -343],
    "s": [90, 4, 116],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [289, 58, -343],
    "s": [86, 4, 112],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [289, 62, -343],
    "s": [90, 4, 116],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [378, 54, -350],
    "s": [88, 4, 34],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [471, 54, -323],
    "s": [98, 4, 156],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [405, 54, -268],
    "s": [35, 4, 46],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [407, 58, -268],
    "s": [35, 4, 42],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [471, 58, -323],
    "s": [94, 4, 152],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [378, 58, -350],
    "s": [92, 4, 30],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [378, 62, -350],
    "s": [88, 4, 34],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [471, 62, -323],
    "s": [98, 4, 156],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [405, 62, -268],
    "s": [35, 4, 46],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [289, 0, -343],
    "s": [89, 12, 115],
    "c": "#696969",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [355, 0, -350],
    "s": [45, 12, 33],
    "c": "#696969",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [396, 37, -337],
    "s": [36, 4, 6],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [377, 37, -350],
    "s": [2, 4, 18],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [415, 37, -350],
    "s": [2, 4, 18],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [406, 0, -268],
    "s": [33, 12, 45],
    "c": "#696969",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [471, 0, -323],
    "s": [97, 12, 155],
    "c": "#696969",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [389, 0, -268],
    "s": [2, 12, 34],
    "c": "#696969",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [419, 0, -350],
    "s": [9, 12, 32],
    "c": "#696969",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [396, 2, -246],
    "s": [26, 1, 29],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [389, 2, -279],
    "s": [19, 1, 37],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [419, 2, -298],
    "s": [19, 1, 23],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [404, 2, -293],
    "s": [11, 1, 5],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [424, 2, -316],
    "s": [19, 1, 13],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [424, 2, -349],
    "s": [30, 1, 53],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [407, 2, -358],
    "s": [4, 1, 24],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [378, 2, -284],
    "s": [3, 1, 21],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [393, 2, -230],
    "s": [13, 1, 3],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [428, 2, -393],
    "s": [23, 1, 35],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [420, 2, -513],
    "s": [30, 1, 13],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [415, 2, -383],
    "s": [3, 1, 15],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [433, 2, -428],
    "s": [15, 1, 35],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [397, 2, -514],
    "s": [16, 1, 11],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [330, 2, -525],
    "s": [24, 1, 9],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [423, 2, -438],
    "s": [5, 1, 15],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [372, 0, -561],
    "s": [26, 8, 3],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [372, 0, -558],
    "s": [26, 6, 3],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [372, 0, -555],
    "s": [26, 4, 3],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [404, 9, -563],
    "s": [38, 2, 2],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [386, 2, -563],
    "s": [2, 7, 2],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [422, 2, -563],
    "s": [2, 7, 2],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [358, 2, -563],
    "s": [2, 7, 2],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [320, 2, -563],
    "s": [2, 7, 2],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [339, 9, -563],
    "s": [40, 2, 2],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [426, 0, -456],
    "s": [8, 41, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [426, 0, -584],
    "s": [8, 41, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [418, 0, -592],
    "s": [8, 41, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [324, 0, -592],
    "s": [8, 41, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [316, 0, -584],
    "s": [8, 41, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [316, 0, -456],
    "s": [8, 41, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [297, 41, -527],
    "s": [46, 4, 150],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [371, 41, -590],
    "s": [102, 4, 58],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [297, 45, -527],
    "s": [42, 4, 146],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [371, 45, -590],
    "s": [106, 4, 54],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [297, 49, -535],
    "s": [46, 4, 166],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [371, 49, -590],
    "s": [102, 4, 58],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [420, 2, -528],
    "s": [13, 1, 17],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [420, 2, -560],
    "s": [38, 1, 17],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [420, 2, -544],
    "s": [9, 1, 15],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [395, 2, -560],
    "s": [12, 1, 11],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [372, 2, -556],
    "s": [34, 1, 13],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [367, 2, -547],
    "s": [16, 1, 5],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [320, 2, -561],
    "s": [22, 1, 17],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [348, 2, -560],
    "s": [14, 1, 9],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [336, 2, -560],
    "s": [10, 1, 13],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [320, 2, -541],
    "s": [12, 1, 23],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [321, 2, -513],
    "s": [25, 1, 15],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [342, 2, -515],
    "s": [17, 1, 11],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [352, 2, -514],
    "s": [3, 1, 7],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [409, 2, -524],
    "s": [9, 1, 9],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [413, 2, -549],
    "s": [5, 1, 5],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [274, 2, -517],
    "s": [35, 1, 32],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [300, 2, -517],
    "s": [17, 1, 20],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [285, 13, -229],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [274, 14, -227],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.4, -3.14],
    "c": "#85aa6c"
  }, {
    "p": [206, 14, -227],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.69, 0],
    "c": "#85aa6c"
  }, {
    "p": [193, 14, -240],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.18, 0],
    "c": "#85aa6c"
  }, {
    "p": [193, 14, -293],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.87, 0],
    "c": "#85aa6c"
  }, {
    "p": [193, 14, -352],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": "#85aa6c"
  }, {
    "p": [226, 2, -456],
    "s": [35, 1, 36],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [250, 2, -452],
    "s": [13, 1, 19],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [200, 2, -438],
    "s": [17, 1, 22],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [200, 2, -406],
    "s": [11, 1, 26],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [198, 2, -423],
    "s": [11, 1, 8],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [217, 2, -436],
    "s": [17, 1, 4],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [263, 2, -456],
    "s": [13, 1, 10],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [249, 13, -299],
    "s": [21, 1, 39],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [245, 13, -323],
    "s": [11, 1, 9],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [245, 13, -338],
    "s": [8, 1, 21],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [237, 13, -296],
    "s": [3, 1, 26],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [273, 13, -284],
    "s": [27, 1, 5],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [75, 13, -450],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [242, 13, -302],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [242, 14, -309],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#85aa6c"
  }, {
    "p": [253, 2, -398],
    "s": [29, 1, 15],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [286, 2, -402],
    "s": [37, 1, 14],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [328, 2, -384],
    "s": [21, 1, 47],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [311, 2, -402],
    "s": [13, 1, 7],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [347, 2, -372],
    "s": [17, 1, 17],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [370, 2, -362],
    "s": [29, 1, 28],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [342, 2, -389],
    "s": [7, 1, 17],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [289, 2, -412],
    "s": [24, 1, 6],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [249, 2, -407],
    "s": [13, 1, 3],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [368, 2, -339],
    "s": [29, 1, 18],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [339, 2, -332],
    "s": [29, 1, 18],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [334, 2, -316],
    "s": [23, 1, 14],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [330, 2, -295],
    "s": [19, 1, 28],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [363, 2, -329],
    "s": [19, 1, 2],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [386, 2, -365],
    "s": [3, 1, 18],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [349, 2, -382],
    "s": [7, 1, 3],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [363, 2, -377],
    "s": [15, 1, 2],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [417, 3, -371],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.7, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [417, 3, -295],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.52, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [417, 3, -328],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.35, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [348, 3, -329],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, 0.17, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [339, 3, -328],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.53, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [430, 3, -405],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.13, -1.4, 3.13],
    "c": "#85aa6c"
  }, {
    "p": [427, 3, -446],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.04, 0],
    "c": "#85aa6c"
  }, {
    "p": [288, 3, -508],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.71, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [243, 3, -446],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.54, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [200, 3, -443],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.19, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [210, 3, -444],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, 0.86, -3.14],
    "c": "#85aa6c"
  }, {
    "p": [198, 3, -419],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -1.06, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [297, 3, -405],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.71, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [287, 2, -407],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [287, 14, -407],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [338, 3, -371],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.21, 0],
    "c": "#85aa6c"
  }, {
    "p": [368, 3, -371],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -1.41, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [355, 3, -558],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.54, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [390, 3, -558],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -1.06, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [418, 3, -558],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.38, 0],
    "c": "#85aa6c"
  }, {
    "p": [418, 3, -520],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0],
    "c": "#85aa6c"
  }, {
    "p": [322, 3, -521],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.34, 0],
    "c": "#85aa6c"
  }, {
    "p": [323, 3, -559],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0],
    "c": "#85aa6c"
  }, {
    "p": [334, 10, -570],
    "s": [9, 4, 9],
    "l": 1,
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [334, 37, -570],
    "s": [9, 4, 9],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [334, -11, -570],
    "s": [8, 48, 8],
    "c": "#707070",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [392, 10, -570],
    "s": [9, 4, 9],
    "l": 1,
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [392, 37, -570],
    "s": [9, 4, 9],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [392, -11, -570],
    "s": [8, 48, 8],
    "c": "#707070",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [352, 10, -570],
    "s": [9, 4, 9],
    "l": 1,
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [352, 37, -570],
    "s": [9, 4, 9],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [352, -11, -570],
    "s": [8, 48, 8],
    "c": "#707070",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [410, 10, -570],
    "s": [9, 4, 9],
    "l": 1,
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [410, 37, -570],
    "s": [9, 4, 9],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [410, -11, -570],
    "s": [8, 48, 8],
    "c": "#707070",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [361, 10, -590],
    "s": [4, 22, 4],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [383, 10, -590],
    "s": [4, 22, 4],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [372, 32, -590],
    "s": [27, 4, 5],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [371, 2, -590],
    "s": [23, 30, 3],
    "c": "#b9b9b9",
    "t": 2
  }, {
    "p": [325, -7, -643],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.36, 0],
    "c": "#4c663e"
  }, {
    "p": [431, -14, -643],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [3.14, -1.04, 3.14],
    "c": "#4c663e"
  }, {
    "p": [483, -14, -498],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [3.14, -1.04, 3.14],
    "c": "#4c663e"
  }, {
    "p": [501, -25, -489],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [3.14, 1.05, -3.14],
    "c": "#4c663e"
  }, {
    "p": [529, -30, -414],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [3.14, 1.05, -3.14],
    "c": "#4c663e"
  }, {
    "p": [482, -31, -599],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [3.14, 0.36, -3.14],
    "c": "#4c663e"
  }, {
    "p": [378, -20, -659],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [3.14, -0.86, 3.14],
    "c": "#4c663e"
  }, {
    "p": [270, -21, -643],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -1.41, 0],
    "c": "#4c663e"
  }, {
    "p": [356, -23, -384],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -1.06, 0],
    "c": "#4c663e"
  }, {
    "p": [333, 2, -522],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [357, 0, -383],
    "s": [5, 35, 5],
    "v": 1,
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [357, 0, -383],
    "s": [6, 35, 6],
    "v": 1,
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [413, 33, -234],
    "s": [1, 33, 1],
    "l": 1,
    "c": "#8e8e8e",
    "t": 2
  }, {
    "p": [413, 66, -243],
    "s": [2, 2, 21],
    "c": "#c8c8c8",
    "t": 2,
    "bo": 1
  }, {
    "p": [413, 58, -247],
    "s": [1, 14, 2],
    "l": 1,
    "r": [0.87, 0, 0],
    "c": "#c8c8c8",
    "t": 2
  }, {
    "p": [272, 66, -401],
    "s": [2, 2, 20],
    "c": "#c8c8c8",
    "t": 2,
    "bo": 1
  }, {
    "p": [272, 57, -398],
    "s": [1, 13, 2],
    "l": 1,
    "r": [-0.7, 0, 0],
    "c": "#c8c8c8",
    "t": 2
  }, {
    "p": [272, 39, -410],
    "s": [1, 27, 1],
    "l": 1,
    "c": "#8e8e8e",
    "t": 2
  }, {
    "p": [396, 37, -363],
    "s": [36, 4, 6],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [411, 37, -350],
    "s": [6, 4, 20],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [381, 37, -350],
    "s": [6, 4, 20],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [395, 40, -350],
    "s": [26, 1, 20],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [273, 13, -281],
    "s": [3, 15, 1],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": "#a7a7a7",
    "t": 2
  }, {
    "p": [266, 13, -281],
    "s": [3, 15, 1],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": "#a7a7a7",
    "t": 2
  }, {
    "p": [-42, 2, -75],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": 0
  }, {
    "p": [372, 2, -529],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": "1"
  }, {
    "p": [-5, 21, -432],
    "s": [68, 50, 57],
    "i": 14,
    "l": 1
  }, {
    "p": [457, 2, -67],
    "s": [47, 35, 119],
    "i": 14,
    "l": 1
  }, {
    "p": [371, 2, -539],
    "s": [100, 35, 44],
    "i": 14,
    "l": 1
  }, {
    "p": [60, 2, -203],
    "s": [103, 35, 71],
    "i": 14,
    "l": 1
  }, {
    "p": [96, 0, -144],
    "s": [47, 34, 44],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [51, 2, -240],
    "s": [34, 1, 18],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [79, 2, -240],
    "s": [22, 1, 23],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [77, 2, -209],
    "s": [20, 1, 6],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [76, 2, -216],
    "s": [15, 1, 8],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [75, 2, -205],
    "s": [11, 1, 2],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [102, 2, -240],
    "s": [24, 1, 45],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [106, 2, -212],
    "s": [15, 1, 11],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [108, 2, -196],
    "s": [9, 1, 21],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [104, 2, -175],
    "s": [19, 1, 21],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [81, 2, -163],
    "s": [27, 1, 19],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [88, 2, -175],
    "s": [13, 1, 5],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [5, 2, -199],
    "s": [12, 1, 2],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [22, 2, -221],
    "s": [6, 1, 14],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [60, 0, -240],
    "s": [105, 12, 1],
    "c": "#696969",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [113, 0, -202],
    "s": [2, 12, 75],
    "c": "#696969",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [96, 0, -166],
    "s": [32, 12, 1],
    "c": "#696969",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [105, 2, -174],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [108, 2, -183],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [108, 2, -189],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [107, 3, -234],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.86, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [108, 3, -223],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, 0.36, -3.14],
    "c": "#85aa6c"
  }, {
    "p": [108, 3, -196],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.51, -3.14],
    "c": "#85aa6c"
  }, {
    "p": [94, 3, -171],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -1.21, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [-55, -35, -570],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#4c663e"
  }, {
    "p": [495, -41, -439],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [3.14, -0.34, -3.14],
    "c": "#4c663e"
  }, {
    "p": [66, 2, -211],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [54, 2, -211],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [398, 2, -514],
    "s": [5, 14, 4],
    "e": "#18180a"
  }, {
    "p": [406, 2, -514],
    "s": [11, 3, 4],
    "e": "#18180a"
  }, {
    "p": [406, 14, -514],
    "s": [11, 2, 4],
    "e": "#18180a"
  }, {
    "p": [406, 5, -512],
    "s": [5, 11, 1],
    "pe": 1,
    "c": "#acaaaa",
    "t": 2
  }, {
    "p": [402, 4, -512],
    "s": [3, 11, 1],
    "pe": 1,
    "c": "#acaaaa",
    "t": 2
  }, {
    "p": [410, 4, -512],
    "s": [3, 11, 1],
    "pe": 1,
    "c": "#acaaaa",
    "t": 2
  }, {
    "p": [410, 2, -521],
    "s": [5, 3, 4],
    "l": 1,
    "r": [0, 0.7, 0],
    "e": "#18180a"
  }, {
    "p": [142, 0, -119],
    "s": [127, 2, 8],
    "v": 1,
    "c": "#ffffff",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [7, 34, -228],
    "s": [2, 12, 26],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [409, 30, -179],
    "s": [40, 5, 6],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [392, 0, -179],
    "s": [5, 30, 6],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [427, 0, -179],
    "s": [5, 30, 6],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [433, 0, -180],
    "s": [8, 56, 6],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [437, 8, -152],
    "s": [1, 50, 34],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [439, 0, -52],
    "s": [8, 8, 9],
    "c": "#696969",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [436, 0, -172],
    "s": [1, 56, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [391, 35, -179],
    "s": [14, 18, 5],
    "c": "#ffffff",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [344, 42, -172],
    "s": [4, 6, 9],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [432, 0, -177],
    "s": [7, 8, 4],
    "c": "#696969",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [433, 0, -176],
    "s": [8, 56, 1],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [214, -55, -321],
    "s": [619, 35, 929],
    "c": "#39301f",
    "t": 5
  }, {
    "p": [439, 8, -52],
    "s": [7, 37, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [439, 8, -92],
    "s": [7, 34, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [439, 8, -132],
    "s": [7, 34, 8],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [437, 47, -68],
    "s": [1, 11, 134],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [441, 39, -214],
    "s": [7, 4, 49],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [463, 42, -71],
    "s": [52, 4, 130],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [478, 8, -3],
    "s": [7, 34, 7],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [485, 8, -10],
    "s": [7, 34, 7],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [478, 8, -131],
    "s": [7, 34, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [485, 8, -124],
    "s": [7, 34, 7],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [439, 0, -92],
    "s": [8, 8, 9],
    "c": "#696969",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [460, 0, -152],
    "s": [50, 8, 49],
    "c": "#696969",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [459, 8, -132],
    "s": [33, 35, 7],
    "c": "#ffffff",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [485, 0, -67],
    "s": [8, 8, 125],
    "c": "#696969",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [485, 8, -67],
    "s": [6, 34, 125],
    "c": "#ffffff",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [465, -17, -188],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, 0.87, 0],
    "c": "#4c663e"
  }, {
    "p": [504, -29, -216],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -1.05, 0],
    "c": "#4c663e"
  }, {
    "p": [544, -13, -253],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [3.14, -0.7, 3.14],
    "c": "#4c663e"
  }, {
    "p": [528, -36, -167],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [-3.14, 0.53, -3.14],
    "c": "#4c663e"
  }, {
    "p": [471, -37, -159],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.18, 0],
    "c": "#4c663e"
  }, {
    "p": [528, -66, -203],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [-3.14, 0.53, -3.14],
    "c": "#4c663e"
  }, {
    "p": [278, 0, -456],
    "s": [8, 41, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [445, 0, -534],
    "s": [44, 41, 162],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [445, 41, -527],
    "s": [46, 4, 150],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [445, 45, -527],
    "s": [42, 4, 146],
    "c": "#e8e8e8",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [445, 49, -536],
    "s": [46, 4, 168],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [316, 0, -514],
    "s": [8, 41, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [426, 0, -514],
    "s": [8, 41, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [317, 2, -452],
    "s": [29, 1, 15],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [286, 2, -456],
    "s": [33, 1, 16],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [289, 2, -447],
    "s": [14, 1, 2],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [321, 2, -443],
    "s": [17, 1, 3],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [433, 2, -457],
    "s": [37, 1, 23],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [410, 2, -469],
    "s": [9, 1, 25],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [406, 2, -493],
    "s": [4, 1, 13],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [410, 2, -494],
    "s": [4, 1, 25],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [394, 2, -181],
    "s": [7, 1, 20],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [385, 2, -175],
    "s": [11, 1, 6],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [399, 2, -179],
    "s": [3, 1, 12],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [417, 2, -246],
    "s": [16, 1, 19],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [433, 2, -234],
    "s": [16, 1, 34],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [434, 2, -212],
    "s": [10, 1, 10],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [434, 2, -182],
    "s": [26, 1, 22],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [434, 2, -200],
    "s": [16, 1, 14],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [420, 2, -179],
    "s": [2, 1, 10],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [434, 2, -169],
    "s": [12, 1, 4],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [221, 13, -229],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [221, 13, -213],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [209, 13, -213],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [421, 53, -483],
    "s": [21, 2, 2],
    "c": "#c8c8c8",
    "t": 2,
    "bo": 1
  }, {
    "p": [425, 44, -483],
    "s": [2, 13, 1],
    "l": 1,
    "r": [0, 0, 0.7],
    "c": "#c8c8c8",
    "t": 2
  }, {
    "p": [412, 30, -483],
    "s": [1, 23, 1],
    "l": 1,
    "c": "#8e8e8e",
    "t": 2
  }, {
    "p": [418, 2, -515],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.89, 0],
    "c": "#85aa6c"
  }, {
    "p": [413, 0, -485],
    "s": [3, 8, 45],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [413, 8, -485],
    "s": [4, 2, 46],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [419, 0, -506],
    "s": [9, 8, 3],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [419, 0, -464],
    "s": [9, 8, 3],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [419, 8, -506],
    "s": [8, 2, 4],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [419, 8, -464],
    "s": [8, 2, 4],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [419, 0, -485],
    "s": [9, 4, 40],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [419, 2, -455],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.06, 0],
    "c": "#85aa6c"
  }, {
    "p": [426, 1, -500],
    "s": [8, 33, 4],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [426, 1, -470],
    "s": [8, 33, 4],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [426, 34, -485],
    "s": [9, 4, 37],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [426, 19, -485],
    "s": [9, 1, 5],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [426, 22, -485],
    "s": [9, 1, 5],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [426, 19, -488],
    "s": [9, 4, 1],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [426, 19, -482],
    "s": [9, 4, 1],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [421, 6, -485],
    "s": [1, 15, 5],
    "l": 1,
    "c": "#2787ca",
    "o": 0.7000000000000001,
    "t": 8,
    "ts": 5,
    "td": 1,
    "ab": 1
  }, {
    "p": [419, 4, -485],
    "s": [10, 2, 39],
    "l": 1,
    "c": "#2787ca",
    "o": 0.7000000000000001,
    "t": 8,
    "ts": -0.1,
    "td": 1,
    "ab": 1
  }, {
    "p": [426, 20, -485],
    "s": [8, 2, 5],
    "c": "#000000",
    "e": "#18180a"
  }, {
    "p": [329, 0, -485],
    "s": [3, 8, 45],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [329, 8, -485],
    "s": [4, 2, 46],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [323, 0, -464],
    "s": [9, 8, 3],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [323, 0, -506],
    "s": [9, 8, 3],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [323, 8, -464],
    "s": [8, 2, 4],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [323, 8, -506],
    "s": [8, 2, 4],
    "c": "#939393",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [323, 0, -485],
    "s": [9, 4, 40],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [316, 1, -470],
    "s": [8, 33, 4],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [316, 1, -500],
    "s": [8, 33, 4],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [316, 34, -485],
    "s": [9, 4, 37],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [316, 19, -485],
    "s": [9, 1, 5],
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [316, 22, -485],
    "s": [9, 1, 5],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [316, 19, -482],
    "s": [9, 4, 1],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [316, 19, -488],
    "s": [9, 4, 1],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [321, 6, -485],
    "s": [1, 15, 5],
    "l": 1,
    "c": "#2787ca",
    "o": 0.7000000000000001,
    "t": 8,
    "ts": 5,
    "td": 1,
    "ab": 1
  }, {
    "p": [323, 4, -485],
    "s": [10, 2, 39],
    "l": 1,
    "c": "#2787ca",
    "o": 0.7000000000000001,
    "t": 8,
    "ts": -0.1,
    "td": 1,
    "ab": 1
  }, {
    "p": [316, 20, -485],
    "s": [8, 2, 5],
    "c": "#000000",
    "e": "#18180a"
  }, {
    "p": [320, 2, -473],
    "s": [33, 1, 27],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [320, 2, -496],
    "s": [30, 1, 19],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [338, 2, -476],
    "s": [3, 1, 14],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [324, 3, -458],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.13, -1.41, 3.13],
    "c": "#85aa6c"
  }, {
    "p": [433, 3, -188],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.7, -3.14],
    "c": "#85aa6c"
  }, {
    "p": [432, 3, -240],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.17, -3.14],
    "c": "#85aa6c"
  }, {
    "p": [422, 3, -241],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.53, -3.14],
    "c": "#85aa6c"
  }, {
    "p": [240, 13, -221],
    "s": [14, 3, 4],
    "e": "#18180a"
  }, {
    "p": [241, 16, -219],
    "s": [4, 13, 1],
    "pe": 1,
    "c": "#b1b1b1",
    "t": 2
  }, {
    "p": [245, 16, -219],
    "s": [4, 12, 1],
    "pe": 1,
    "c": "#b1b1b1",
    "t": 2
  }, {
    "p": [236, 15, -219],
    "s": [6, 13, 1],
    "pe": 1,
    "c": "#b1b1b1",
    "t": 2
  }, {
    "p": [340, 2, -74],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [477, 2, -37],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [333, 0, -114],
    "s": [8, 8, 125],
    "c": "#696969",
    "e": "#18180a",
    "t": 11
  }, {
    "p": [340, 2, -121],
    "s": [1, 23, 5],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": "#a7a7a7",
    "t": 2
  }, {
    "p": [474, 2, -120],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [474, 2, -108],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [474, 2, -28],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [474, 14, -28],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [340, 2, -80],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-17, 0, -115],
    "s": [18, 38, 2],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-68, 0, -116],
    "s": [20, 12, 1],
    "c": "#696969",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [-28, 0, -115],
    "s": [4, 26, 4],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-42, 26, -115],
    "s": [32, 4, 4],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-56, 0, -115],
    "s": [4, 26, 4],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-1, 0, -107],
    "s": [1, 12, 4],
    "c": "#696969",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [-2, 0, -89],
    "s": [4, 26, 4],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-2, 0, -61],
    "s": [4, 26, 4],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-2, 26, -75],
    "s": [4, 4, 32],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-1, 0, -46],
    "s": [1, 12, 30],
    "c": "#696969",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [-2, 0, -47],
    "s": [2, 38, 24],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-2, 30, -75],
    "s": [2, 8, 32],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-67, 0, -115],
    "s": [18, 38, 2],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-42, 30, -115],
    "s": [32, 8, 2],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-2, 2, -88],
    "s": [9, 1, 10],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-37, 0, -80],
    "s": [72, 2, 72],
    "c": "#434343",
    "e": "#18180a"
  }, {
    "p": [-55, 2, -115],
    "s": [7, 1, 11],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-64, 2, -113],
    "s": [11, 1, 3],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [2, 2, -100],
    "s": [5, 1, 14],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-15, 2, -113],
    "s": [6, 1, 4],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-3, 2, -97],
    "s": [4, 1, 8],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-4, 2, -61],
    "s": [7, 1, 13],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-38, 0, -43],
    "s": [70, 38, 2],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-74, 0, -79],
    "s": [2, 38, 70],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-72, 0, -113],
    "s": [8, 38, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-5, 0, -45],
    "s": [6, 38, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-72, 0, -45],
    "s": [8, 38, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-33, 2, -116],
    "s": [2, 1, 8],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-38, 34, -112],
    "s": [60, 4, 6],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-38, 34, -46],
    "s": [60, 4, 6],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-71, 34, -79],
    "s": [6, 4, 60],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-5, 34, -79],
    "s": [6, 4, 60],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-38, 38, -106],
    "s": [76, 4, 22],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-4, 0, -39],
    "s": [8, 38, 8],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-11, 38, -79],
    "s": [22, 4, 32],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-65, 38, -79],
    "s": [22, 4, 32],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [-17, 2, -47],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#989898",
    "t": 2
  }, {
    "p": [-24, 2, -47],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#989898",
    "t": 2
  }, {
    "p": [-70, 2, -52],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-70, 2, -58],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [369, 2, -458],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [381, 2, -458],
    "s": [12, 12, 12],
    "i": 8,
    "r": [0, 1.57, 0]
  }, {
    "p": [375, 8, -458],
    "s": [24, 7, 12],
    "l": 1,
    "c": "#3964a2",
    "t": 5,
    "ab": 1
  }, {
    "p": [29, 51, -29],
    "s": [12, 8, 1],
    "l": 1,
    "c": "#2f241a",
    "e": "#18180a",
    "t": 5,
    "ab": 1
  }, {
    "p": [29, 59, -29],
    "s": [14, 6, 1],
    "l": 1,
    "c": "#2f241a",
    "e": "#18180a",
    "t": 5,
    "ab": 1
  }, {
    "p": [29, 52, -29],
    "s": [10, 8, 2],
    "l": 1,
    "c": "#7d634b",
    "e": "#18180a",
    "t": 5,
    "ab": 1
  }, {
    "p": [29, 60, -29],
    "s": [12, 4, 2],
    "l": 1,
    "c": "#7d634b",
    "e": "#18180a",
    "t": 5,
    "ab": 1
  }, {
    "p": [333, 2, -514],
    "s": [27, 14, 4],
    "e": "#18180a"
  }, {
    "p": [328, 2, -533],
    "s": [4, 1, 7],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [223, 13, -221],
    "s": [15, 1, 34],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-89, 0, -258],
    "s": [33, 12, 97],
    "c": "#696969",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [-1, 0, -93],
    "s": [1, 12, 4],
    "c": "#696969",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [-1, 0, -100],
    "s": [1, 5, 10],
    "c": "#464646",
    "e": "#18180a",
    "t": 11,
    "bo": 1
  }, {
    "p": [-2, 0, -107],
    "s": [2, 38, 4],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-2, 15, -100],
    "s": [2, 23, 10],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-2, 0, -100],
    "s": [2, 5, 10],
    "c": "#bebebe",
    "e": "#18180a"
  }, {
    "p": [-1, 5, -99],
    "s": [1, 10, 4],
    "pe": 1,
    "c": "#afafaf",
    "t": 2
  }, {
    "p": [-1, 5, -103],
    "s": [1, 11, 4],
    "pe": 1,
    "c": "#afafaf",
    "t": 2
  }, {
    "p": [-1, 5, -96],
    "s": [1, 11, 2],
    "pe": 1,
    "c": "#afafaf",
    "t": 2
  }, {
    "p": [187, 13, -300],
    "s": [4, 4, 14],
    "e": "#18180a"
  }, {
    "p": [187, 13, -312],
    "s": [4, 19, 10],
    "e": "#18180a"
  }, {
    "p": [187, 28, -300],
    "s": [4, 4, 14],
    "e": "#18180a"
  }, {
    "p": [185, 16, -301],
    "s": [1, 12, 4],
    "pe": 1,
    "c": "#b1b1b1",
    "t": 2
  }, {
    "p": [185, 17, -305],
    "s": [1, 12, 4],
    "pe": 1,
    "c": "#b1b1b1",
    "t": 2
  }, {
    "p": [-89, 0, -258],
    "s": [32, 61, 96],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [383, 2, -186],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [363, 19, -186],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [185, 17, -296],
    "s": [1, 12, 6],
    "pe": 1,
    "c": "#b1b1b1",
    "t": 2
  }, {
    "p": [391, 48, -171],
    "s": [8, 5, 9],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [382, 48, -173],
    "s": [4, 1, 3],
    "l": 1,
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [341, 48, -143],
    "s": [8, 5, 9],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [339, 48, -150],
    "s": [4, 1, 3],
    "l": 1,
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [348, 48, -146],
    "s": [4, 2, 3],
    "l": 1,
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [324, 50, -158],
    "s": [10, 10, 14],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [325, 50, -147],
    "s": [12, 13, 9],
    "c": "#a7a7a7",
    "e": "#18180a",
    "bo": 1
  }, {
    "p": [332, 52, -173],
    "s": [5, 1, 5],
    "l": 1,
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [139, 38, -441],
    "s": [35, 72, 116],
    "v": 1,
    "c": "#8e8e8e",
    "t": 8
  }, {
    "p": [332, 52, -157],
    "s": [2, 1, 2],
    "l": 1,
    "c": "#a7a7a7",
    "e": "#18180a"
  }, {
    "p": [367, 2, -144],
    "s": [4, 2, 5],
    "l": 1,
    "r": [-3.14, 0.17, -3.14],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [288, 2, -51],
    "s": [4, 2, 5],
    "l": 1,
    "r": [-3.14, 0.17, -3.14],
    "c": "#ffffff",
    "e": "#18180a"
  }, {
    "p": [-67, 13, -278],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [73, 13, -371],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [382, 2, -265],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-16, 13, -357],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-4, 13, -357],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-10, 25, -357],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-11, 13, -348],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-16, 13, -355],
    "s": [22, 1, 24],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [0, 13, -356],
    "s": [10, 1, 19],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [-4, 14, -347],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.06, 0],
    "c": "#85aa6c"
  }, {
    "p": [-17, 14, -348],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.06, 0],
    "c": "#85aa6c"
  }, {
    "p": [-23, 14, -364],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.41, 0],
    "c": "#85aa6c"
  }, {
    "p": [82, 14, -351],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.33, -3.14],
    "c": "#85aa6c"
  }, {
    "p": [11, 14, -321],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.97, 0],
    "c": "#85aa6c"
  }, {
    "p": [187, 24, -255],
    "s": [4, 1, 3],
    "l": 1,
    "e": "#18180a"
  }, {
    "p": [-69, 14, -300],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -1.03, 3.14],
    "c": "#85aa6c"
  }, {
    "p": [247, 3, -405],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, 0.86, -3.14],
    "c": "#85aa6c"
  }, {
    "p": [393, 3, -511],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.38, 0],
    "c": "#85aa6c"
  }, {
    "p": [124, 2, -64],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [168, 3, -36],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.53, 0],
    "c": "#85aa6c"
  }, {
    "p": [189, 3, 9],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#85aa6c"
  }, {
    "p": [124, 14, -64],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [124, 2, -71],
    "s": [18, 1, 7],
    "l": 1,
    "c": "#8e8e8e",
    "t": 8,
    "ab": 1
  }, {
    "p": [89, 3, -104],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.23, 0],
    "c": "#85aa6c"
  }, {
    "p": [161, 3, -109],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#85aa6c"
  }, {
    "p": [-41, 76, -469],
    "s": [58, 0, 24],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0],
    "sad": 1
  }, {
    "p": [-66, 61, -472],
    "s": [4, 30, 3],
    "l": 1,
    "c": "#3e352b",
    "e": "#18180a",
    "t": 5
  }, {
    "p": [-41, 63, -470],
    "s": [61, 26, 1],
    "l": 1,
    "c": "#3e352b",
    "e": "#18180a",
    "t": 5
  }, {
    "p": [-15, 61, -472],
    "s": [4, 30, 3],
    "l": 1,
    "c": "#3e352b",
    "e": "#18180a",
    "t": 5
  }, {
    "p": [431, 69, -527],
    "s": [54, 0, 21],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -1.57],
    "sad": 1
  }, {
    "p": [434, 52, -503],
    "s": [4, 30, 3],
    "l": 1,
    "c": "#3e352b",
    "e": "#18180a",
    "t": 5
  }, {
    "p": [434, 52, -550],
    "s": [4, 30, 3],
    "l": 1,
    "c": "#3e352b",
    "e": "#18180a",
    "t": 5
  }, {
    "p": [432, 57, -527],
    "s": [1, 23, 57],
    "l": 1,
    "c": "#3e352b",
    "e": "#18180a",
    "t": 5
  }, {
    "p": [291, 38, -284],
    "s": [58, 0, 23],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0],
    "sad": 1
  }, {
    "p": [291, 25, -285],
    "s": [62, 26, 1],
    "l": 1,
    "c": "#3e352b",
    "t": 5
  }]
}